// This exists so I'm only saving it once.
"use strict"

module.exports = {}.hasOwnProperty
